import { AfterViewInit, Component, Input, ViewEncapsulation } from '@angular/core';
import * as moment from 'moment';
import { TIME_FORMAT } from '../utils/timeUtils';
import { FormControl } from '@angular/forms';
import randomString from '../utils/randomString';

@Component({
  selector: 'cc-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TimepickerComponent implements AfterViewInit {
  @Input() public hoursFormControl: FormControl = new FormControl();
  @Input() public placeholder = '';
  @Input() public class = '';
  @Input() public step = 15;
  @Input() public timeFormat = 'h:i A';

  public identifier = randomString();

  ngAfterViewInit() {
    const input = $(`#${this.identifier}`);
    const initialTime = this.hoursFormControl.value;
    const onSelectTime = this.onSelectTime.bind(this);

    this.hoursFormControl.valueChanges.subscribe((value: string) => {
      input.timepicker('setTime', this.parseTime(value));
    });

    input
      .timepicker({
        step: this.step,
        timeFormat: this.timeFormat
      })
      .timepicker('setTime', initialTime)
      .on('change', function() {
        onSelectTime($(this).timepicker('getTime'));
      });
  }

  private parseTime(time: string): Date {
    return moment(time, TIME_FORMAT).toDate();
  }

  private onSelectTime(selectedDateTime: Date) {
    const time: string = moment(selectedDateTime).format(TIME_FORMAT);
    this.hoursFormControl.setValue(time);
  }
}
